import { render, staticRenderFns } from "./ViewerToolbar.vue?vue&type=template&id=2fb8f6d8"
import script from "./ViewerToolbar.vue?vue&type=script&lang=js"
export * from "./ViewerToolbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports